import { ScanLine, Ticket, Smartphone, Wallet } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

function StampVisual() {
  return (
    <div className="flex h-56 flex-col justify-center gap-3 rounded-2xl bg-ink p-6">
      <div className="flex items-center justify-between rounded-xl bg-white/95 p-3.5 shadow-xl">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cream-deep text-ink-soft text-xs font-bold">
            M
          </div>
          <div>
            <p className="text-xs font-bold text-ink">Marie Dupont</p>
            <p className="text-[11px] text-ink-soft">5/8 tampons</p>
          </div>
        </div>
        <span className="flex items-center gap-1 rounded-full bg-gradient-brand px-3 py-1.5 text-xs font-bold text-white">
          <ScanLine size={12} /> +1
        </span>
      </div>
      <p className="text-center text-[11px] text-white/40">Mis à jour dans son wallet, instantanément</p>
    </div>
  );
}

function QrStepsVisual() {
  const steps = [
    { icon: Ticket, text: "QR affiché en caisse" },
    { icon: Smartphone, text: "Le client scanne, entre nom et email" },
    { icon: Wallet, text: "Sa carte arrive dans son wallet" },
  ];
  return (
    <div className="flex h-56 flex-col justify-center gap-3 rounded-2xl bg-ink p-6">
      {steps.map((s, i) => (
        <div key={s.text} className="flex items-center gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white">
            <s.icon size={15} />
          </div>
          <p className="text-xs text-white/80">{s.text}</p>
          {i < steps.length - 1 && <span className="ml-auto shrink-0 text-white/20">↓</span>}
        </div>
      ))}
    </div>
  );
}

const rows = [
  {
    icon: ScanLine,
    accent: "bg-orange/10 text-orange",
    tag: "Tamponnage",
    title: "Un tampon ajouté en un clic, depuis le comptoir.",
    description:
      "Depuis votre tableau de bord — ordinateur, tablette ou téléphone — un clic suffit. La carte du client se met à jour en temps réel dans son wallet.",
    visual: <StampVisual />,
  },
  {
    icon: Ticket,
    accent: "bg-coral/10 text-coral",
    tag: "Inscription",
    title: "Le client crée sa propre carte, sans vous.",
    description:
      "Un QR affiché en caisse suffit à mettre en place l'inscription — le client scanne, entre son nom et son email, et repart avec sa carte. Rien à configurer côté technique.",
    visual: <QrStepsVisual />,
  },
];

export function OperationalFeatures() {
  return (
    <section className="bg-cream-deep py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Opérationnel</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Zéro geste en plus
            <br />
            <span className="text-gradient">au comptoir.</span>
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Rien à installer, rien à brancher — la mise en place tient en quelques minutes.
          </p>
        </Reveal>

        <div className="mt-16 flex flex-col gap-16">
          {rows.map((row, i) => (
            <div key={row.tag} className="grid items-center gap-10 lg:grid-cols-2">
              <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-2" : ""}>
                <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wide ${row.accent}`}>
                  <row.icon size={14} />
                  {row.tag}
                </span>
                <h3 className="mt-4 text-2xl font-extrabold tracking-tight text-ink">{row.title}</h3>
                <p className="mt-3 text-ink-soft">{row.description}</p>
              </Reveal>

              <Reveal delay={0.15} className={i % 2 === 1 ? "lg:order-1" : ""}>
                {row.visual}
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
